/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* A flexible carousel UI component for VDK Web. (@accedo/vdkweb-carousel) 6.0.4
* 
*******************************************************************************/
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _this = this;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import T from 'prop-types';
import SlickCarousel from '@accedo/vdkweb-react-slick';
import CarouselItemBase from './CarouselItemBase';
var CarouselComponent = function CarouselComponent(props) {
  var displayObject = props.displayObject,
    itemStyle = props.itemStyle,
    items = props.items,
    keyProperty = props.keyProperty,
    onItemClick = props.onItemClick,
    options = props.options,
    responsiveSettings = props.responsiveSettings;
  var carouselItems = items.map(function (item, index) {
    var key = item && item[keyProperty] ? item[keyProperty] : "item-".concat(index);
    return /*#__PURE__*/React.createElement("div", {
      key: key
    }, item ? /*#__PURE__*/React.createElement(CarouselItemBase, {
      id: key,
      item: item,
      onClick: onItemClick && onItemClick.bind(_this, item),
      style: itemStyle
    }, /*#__PURE__*/React.cloneElement(displayObject, _objectSpread(_objectSpread({}, displayObject.props), {}, {
      item: item
    }))) : /*#__PURE__*/React.createElement("div", {
      id: key,
      style: itemStyle
    }));
  });
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SlickCarousel, _extends({}, options, {
    responsive: responsiveSettings
  }), carouselItems));
};
CarouselComponent.propTypes = {
  displayObject: T.element,
  items: T.array,
  itemStyle: T.any,
  keyProperty: T.string,
  onItemClick: T.func,
  options: T.any,
  responsiveSettings: T.any
};
export default CarouselComponent;